import { render, staticRenderFns } from "./BibliotecaTable.vue?vue&type=template&id=581ad93f&"
import script from "./BibliotecaTable.vue?vue&type=script&lang=ts&"
export * from "./BibliotecaTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports